/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	console.log('infographics');

	const format = (number)=>{
		return Number(number.replace(/,/g, ''));
	};
	// カウントアップ
	const countUp = (target, add, increment, interval) => {
		let thisNum = target.text();
		// タイマーセット
		let timerId = setInterval(()=>{
			if(format(thisNum) < add) {
				if(add - format(thisNum) < increment) {
					if(target.hasClass('_decimal')) {
						increment = 0.1;
					} else {
						increment = 1;
					}
				}
				thisNum = format(thisNum) + increment;
				thisNum = Number(thisNum).toLocaleString();
				target.text(thisNum);
			} else {
				// タイマークリア
				clearInterval(timerId);
				target.parents('.js-animation-count').addClass(a);
			}
		}, interval);
	};

	// アニメーション
	const inviewItemsAnimation = () => {
		$('.js-animation-head').each((idx, ele) => {
			$(ele).waypoint(function(direction){
				$(ele).addClass(a);
			}, { offset : '80%' });
		});

		$('.js-animation-img').each((idx, ele) => {
			$(ele).waypoint(function(direction){
				$(ele).addClass(a);
			}, { offset : '80%' });
		});
		$('.js-animation-count').each((idx, ele) => {
			$(ele).waypoint(function(direction){
				const target = $(ele).find('._num').not('._noCount');
				const add = $(ele).find('._num').text();
				let increment = 1;
				let interval = 10;
				let thisW = $(ele).outerWidth() + 5;

				if(!$(ele).hasClass(v)) {
					$(ele).css('width', thisW);
					target.text(0);
					$(ele).addClass(v);
					// 指定があるものは個別にincrementを設定
					if($(ele).find('._count').hasClass('_increment')) {
						increment = Number($(ele).find('._count').attr('data-increment'));
					}
					// 指定があるものは個別にintervalを設定
					if($(ele).find('._count').hasClass('_interval')) {
						interval = 1;
					}
					// カウントアップの処理を実行する
					setTimeout(() => {
						countUp(target, format(add), increment, interval);
					}, 700);
				};
			}, { offset : '80%' });
		});
		$('.js-animation-graph').waypoint(function(direction){
			$('.js-animation-graph').addClass(a);
		}, { offset : '50%' });
	};

	// ==============================================================================
	inviewItemsAnimation();


})(window.jQuery, window.FUNCTIONS);